import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35a1aa8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title" }, " 沁禾青果 ", -1))
const _hoisted_3 = {
  key: 0,
  class: "setion_shadow_box form-card"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "form-label" }, "選擇列印類型", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("訂單備貨統整(excel)")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("訂單客人統整(excel)")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("待出貨商品(excel)")
const _hoisted_8 = { class: "marginTop_1rem" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "form-label" }, "開始時間", -1))
const _hoisted_10 = { class: "marginTop_1rem" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "form-label" }, "結束時間", -1))
const _hoisted_12 = {
  key: 0,
  class: "marginTop_1rem"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "form-label" }, "選擇訂單狀態", -1))
const _hoisted_14 = {
  key: 1,
  class: "marginTop_1rem"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "form-label" }, "運送類型", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("運送")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("自取")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("預購")
const _hoisted_20 = { class: "marginTop_1rem" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("匯出並檢視")
const _hoisted_22 = {
  key: 1,
  class: "preview-card"
}
const _hoisted_23 = { class: "preview-header" }
const _hoisted_24 = { class: "preview-title" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("返回修改條件")
const _hoisted_26 = { class: "excel-preview-container" }
const _hoisted_27 = { class: "excel-table" }

import { ref } from "vue";
import dayjs from "dayjs";
import { ElLoading, ElMessage } from "element-plus";
import * as XLSX from "xlsx";
import { getCustomerOrderExcel, getOrderDetailExcel } from "@/service/print";
import { getOrderGoods } from "@/service/order";

enum OrderStatus {
  Delete = 0,
  WaitForPayment = 1,
  WaitForShipping = 2,
  WaitForCustomerGetPackage = 3,
  Complete = 4,
}

enum PrintMode {
  OrderSummary = "1",
  CustomerSummary = "2",
  PendingShipment = "3"
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const startDate = ref();
const endDate = ref();
const printMode = ref<PrintMode>(PrintMode.OrderSummary);
const selectOrderStatus = ref<number | "all">(OrderStatus.WaitForShipping);
const addressStatus = ref("全部");

const showForm = ref(true);
const excelData = ref<any[][]>([]);
const currentReportName = ref("");

const orderStatusOptions = ref([
  { name: "全部", value: "all" },
  { name: "待付款", value: OrderStatus.WaitForPayment },
  { name: "待出貨", value: OrderStatus.WaitForShipping },
  { name: "待收貨", value: OrderStatus.WaitForCustomerGetPackage },
  { name: "已完成", value: OrderStatus.Complete },
]);

const renderExcel = (base64Data: string) => {
  const binaryString = window.atob(base64Data);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const workbook = XLSX.read(bytes.buffer, { type: "array" });
  const firstSheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[firstSheetName];

  const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  excelData.value = jsonData as any[][];
};

const exportData = () => {
  if (!startDate.value || !endDate.value) {
    ElMessage.warning("請選擇完整的開始與結束日期");
    return;
  }

  if (dayjs(startDate.value).isAfter(dayjs(endDate.value))) {
    ElMessage.warning("開始日期不能大於結束日期");
    return;
  }

  const loading = ElLoading.service();

  if (printMode.value === PrintMode.PendingShipment) {
    currentReportName.value = "待出貨商品(excel)";
    getOrderGoods({
      startAt: dayjs(startDate.value).startOf("day").toISOString(),
      endAt: dayjs(endDate.value).endOf("day").toISOString(),
      timeType: "deliveryTime",
    })
      .then((res) => {
        const rows: Array<{
          goodsName: string;
          goodsSkuName: string;
          totalAmount: number;
          quantity: number;
          orderPeopleNames: string[];
        }> = res.data;

        if (!rows || rows.length === 0) {
          ElMessage.error("無資料");
          loading.close();
          return;
        }

        excelData.value = [
          ["商品名稱", "總下訂金額", "總下訂數量", "總訂購人數"],
          ...rows.map((row) => [
            `${row.goodsName}(${row.goodsSkuName})`,
            row.totalAmount,
            row.quantity,
            row.orderPeopleNames.length,
          ]),
        ];
        showForm.value = false;
        ElMessage.success("讀取報表成功");
        loading.close();
      })
      .catch(() => {
        loading.close();
      });
    return;
  }

  const param: {
    startTime: string;
    endTime: string;
    orderStatus?: number;
    isSelfPickup?: boolean;
    preOrder?: boolean;
    logoUrl?: string;
  } = {
    startTime: dayjs(startDate.value).startOf("day").toISOString(),
    endTime: dayjs(endDate.value).endOf("day").toISOString(),
    orderStatus:
      selectOrderStatus.value === "all" ? undefined : selectOrderStatus.value,
    logoUrl: "沁禾青果",
  };

  if (addressStatus.value === "運送") param.isSelfPickup = false;
  if (addressStatus.value === "自取") param.isSelfPickup = true;
  if (addressStatus.value === "預購") param.preOrder = true;

  const apiMap = {
    [PrintMode.OrderSummary]: {
      api: getOrderDetailExcel,
      name: "訂單備貨統整(excel)",
    },
    [PrintMode.CustomerSummary]: {
      api: getCustomerOrderExcel,
      name: "訂單客人統整(excel)",
    },
  };

  const currentConfig = apiMap[printMode.value as PrintMode.OrderSummary | PrintMode.CustomerSummary];
  currentReportName.value = currentConfig.name;

  currentConfig
    .api(param)
    .then((res) => {
      if (!res.data) {
        ElMessage.error("無資料");
      } else {
        renderExcel(res.data);
        showForm.value = false;
        ElMessage.success("讀取報表成功");
      }
      loading.close();
    })
    .catch(() => {
      loading.close();
    });
};

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (showForm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _createVNode(_component_el_radio_group, {
              modelValue: printMode.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((printMode).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: PrintMode.OrderSummary
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_radio, {
                  label: PrintMode.CustomerSummary
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_radio, {
                  label: PrintMode.PendingShipment
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_el_date_picker, {
              modelValue: startDate.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startDate).value = $event)),
              type: "date",
              placeholder: "選擇開始日期",
              style: {"width":"100%"},
              editable: false
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_el_date_picker, {
              modelValue: endDate.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event)),
              type: "date",
              placeholder: "選擇結束日期",
              style: {"width":"100%"},
              editable: false
            }, null, 8, ["modelValue"])
          ]),
          (printMode.value !== PrintMode.PendingShipment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_el_select, {
                  modelValue: selectOrderStatus.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectOrderStatus).value = $event)),
                  placeholder: "請選擇訂單狀態",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderStatusOptions.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.name,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (printMode.value !== PrintMode.PendingShipment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_el_radio_group, {
                  modelValue: addressStatus.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addressStatus).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "全部" }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "運送" }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "自取" }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "預購" }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: exportData,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h3", _hoisted_24, "報表預覽：" + _toDisplayString(currentReportName.value), 1),
            _createVNode(_component_el_button, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (showForm.value = true))
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("table", _hoisted_27, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(excelData.value, (row, rowIndex) => {
                  return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, cellIndex) => {
                      return (_openBlock(), _createElementBlock("td", { key: cellIndex }, _toDisplayString(cell), 1))
                    }), 128))
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
  ]))
}
}

})